import VueI18n from 'vue-i18n';

import { timeZone } from '@/utils/timeZone';
import getDayName from '@/utils/getDayName';

function _getWorkingTimeFormatted(
  schedule: WorkingSchedule,
  timeZoneOptions: ITimeZoneOptions,
  i18n: VueI18n,
  type?: 'work' | 'pickup' | 'delivery',
): string {
  const key: 'workingTime' | 'pickupSchedule' | 'deliverySchedule' =
    type === 'pickup'
      ? 'pickupSchedule'
      : type === 'delivery'
      ? 'deliverySchedule'
      : 'workingTime';

  const time =
    (schedule.opened
      ? schedule.todayWorkingTime?.endTime
      : schedule.willBeOpened?.startTime) ?? '';
  const parts = time.split(':');

  if (parts && parts.length >= 2) {
    const resultTime = timeZone(
      `${new Date().getFullYear()}-06-10T${parts[0].padStart(2, '0')}:${parts[1].padStart(
        2,
        '0',
      )}:00`,
      { type: 'timeShort', timezone: timeZoneOptions },
    );

    let text: string = '';
    if (schedule.isAllDay) {
      return i18n.t(`global.branch.${key}.workAllDay`).toString();
    } else if (schedule.opened) {
      text = i18n.t(`global.branch.${key}.workUntil`).toString();
    } else {
      if (schedule.willBeOpened) {
        text =
          (schedule.willBeOpened.day === 2
            ? i18n.t(`global.branch.${key}.on`).toString()
            : i18n.t(`global.branch.${key}.on2`).toString()) +
          ' ' +
          getDayName(schedule.willBeOpened.day - 1, i18n, false) +
          ' ';
      }

      text += i18n.t(`global.branch.${key}.at`).toString();
    }

    return text + ' ' + resultTime;
  }

  return '';
}

export default _getWorkingTimeFormatted;
